const baseUrl = process.env.MIX_APP_URL;
const image_baseUrl =  process.env.MIX_APP_IMAGE_URL;

export default {

  socket_url: process.env.MIX_IP_URL+':8000',

  appname: process.env.MIX_APP_NAME,
  merchantname: window.merchantname,
  applogo: image_baseUrl + 'Admin/original/' + window.applogo,
  appurl: process.env.MIX_APP_URL,
  api_url: process.env.MIX_APP_URL+'api/',
  api_url: process.env.MIX_APP_URL+'api/',
  media_path: baseUrl + 'public/',
  app_api_url: process.env.API_URL+'api/v1/',
  base_folder: "/" + window.folderName, //'/drinkspot/', // put base folder path here
  google_key: window.google_map_key,

  //tripetto url
  tripetto_url: 'https://tripetto.app/run/VNJ6726MM8',

  basepath: image_baseUrl + 'assets/images/',
  profile_img: baseUrl + 'images/profile-img.png',
  bannerpath: image_baseUrl + 'Banner/thumb/',

  restauranticon: image_baseUrl + 'Restaurant_Icon_image/original/',
  foodicon: image_baseUrl + 'Admin/original/',
  brandicon: image_baseUrl + 'images/brands/',
  category: image_baseUrl + 'Category/original/',
  faq_category: image_baseUrl + 'faq/original/',
  coupon: image_baseUrl + 'Coupon/original/',
  driver: image_baseUrl + 'driver_profiles/original/',
  sub_product: image_baseUrl + 'SubProduct/',
  product: image_baseUrl + 'Product/',
  product_brand: image_baseUrl + 'Brand/',
  zone: image_baseUrl + 'Location/zones/',
  cuisineicon: image_baseUrl + 'Cuisine/original/',
  driver_document: image_baseUrl + 'Driver/Document/original/',
  restaurantmenu: image_baseUrl + 'Sub_Category/original/',
  date_format: 'DD-MM-YYYY',
  no_image: image_baseUrl + 'assets/images/no-img.png',
  discounticon: image_baseUrl + 'Discount/',
  restaurantmenuitemicon: image_baseUrl + 'Restaurant_Menu_Item_Image/',
  homepageimage: image_baseUrl + 'HomePageLayout/',
  categorypageimage: image_baseUrl + 'CategoryPageLayout/',
  vendorlistingimage: image_baseUrl + 'VendorListingLayout/',
  vendordetailimage: image_baseUrl + 'VendorDetailsLayout/',
  signatureImage: image_baseUrl + 'signature_images/original/',

  whatsnew: baseUrl + 'assets/images/',

  audiofile: baseUrl + 'assets/notification.mp3',
  permissions: {
    dashboard_read: "Dashboard Read",
    order_read: "Order Read",
    order_write: "Order Write",
    dashboard_driver_read: "Dashboard Driver Read",
    eagle_view_read: "Eagle view Read",
    merchant_read: "Merchant Read",
    merchant_write: "Merchant Write",
    driver_read: "Driver Read",
    driver_write: "Driver Write",
    customer_read: "Customer Read",
    customer_write: "Customer Write",
    location_read: "Location Read",
    location_write: "Location Write",
    postal_codes_read: "Postal Code Read",
    postal_codes_write: "Postal Code Write",
    delivery_zone_read: "Delivery Zone Read",
    delivery_zone_write: "Delivery Zone Write",
    promo_code_read: "Promo Code Read",
    promo_code_write: "Promo Code Write",
    banner_read: "Banner Read",
    banner_write: "Banner Write",
    vendor_finance_read: "Vendor Finance Read",
    vendor_finance_write: "Vendor Finance Write",
    driver_finance_read: "Driver Finance Read",
    driver_finance_write: "Driver Finance Write",
    reports_read: "Reports Read",
    reports_write: "Reports Write",
    category_read: "Category Read",
    category_write: "Category Write",
    cuisine_read: "Cuisine Read",
    cuisine_write: "Cuisine Write",
    content_pages_read: "Content Pages Read",
    content_pages_write: "Content Pages Write",
    faq_read: "FAQ Read",
    faq_write: "FAQ Write",
    configuration_read: "Configuration Read",
    configuration_write: "Configuration Write",
    layout_read: "Layout Read",
    layout_write: "Layout Write",
    user_access_read: "User & Access Read",
    user_access_write: "User & Access Write",
    terminology_read: "Terminology Read",
    terminology_write: "Terminology Write",
    logs_read: "Logs Read",
    logs_write: "Logs Write",
    csv_logs_read: "Logs Read",
    csv_logs_write: "Logs Read",
    brand_read: "Brand Read",
    brand_write: "Brand Write",
    faq_category_read: "FAQ Category Read",
    faq_category_write: "FAQ Category Write",
    time_slot_read: "Time Slot Read",
    time_slot_write: "Time Slot Write",
    attribute_read: "Attribute Read",
    attribute_write: "Attribute Write",
    popular_search_read : "Popular Search Read",
    popular_search_write : "Popular Search Write",
    supplier_details_read: "Supplier Read",
    supplier_details_write: "Supplier Write",
    purchasing_read:"Purchasing Price read",
    purchasing_write:"Purchasing Price read"
  },
  default_time_options: [
    { value: '0', text: 'Today' },
    { value: '1', text: 'Yesterday' },
    { value: '6', text: 'Last 7 Days' },
    { value: '29', text: 'Last 30 Days' },
    { value: '101', text: 'Last month' },
    { value: '365', text: 'This year' },
    
  ],
  default_notification_sounds: [
    { value: 'public/sounds/notification.mp3', text: 'Sound 1' },
    { value: 'public/sounds/notification-2.mp3', text: 'Sound 2' },
    { value: 'public/sounds/notification-3.mp3', text: 'Sound 3' },
  ]
}